// @flow

import React, { Component } from 'react';
import { Nav } from 'reactstrap';

import Tab from './Tabs';

import makeUrl from '../../../lib/makeUrl';

type Props = {
  prefix: string,
  active: boolean,
  numberOfDays: number,
  name: string,
  id: string,
  region: string,
};

export default class DayTabsDesktop extends Component<Props> {
  render() {
    const { prefix, active, numberOfDays, name, id, region } = this.props;
    const trekOverviewUrl = id ? makeUrl.trekOverview(name, id, region) : prefix;
    return (
      <div className="overview-tabs-container" id="trek-day-tab">
        <div className="row no-gutters">
          <div className="col-12">
            <div className="container" ref={this.scrollContainer}>
              <Nav tabs className="overview-tabs">
                <Tab text="Overview" url={trekOverviewUrl} active={!active} />
                {new Array(numberOfDays).fill(null).map((n, idx) => {
                  // idx is index and is added to 1 to form day eg. 0 + 1 =  day 1
                  const day = `${idx + 1}`;
                  const dayUrl = makeUrl.goToDay(name, id, Number(day), region);
                  return (
                    <Tab
                      key={day}
                      text={`day ${day}`}
                      url={dayUrl}
                      active={active === day}
                    />
                  );
                })}
              </Nav>
            </div>
          </div>
        </div>
      </div>
    );
  }

  componentDidMount() {
    this.scrollActiveDayTabIntoView();
  }

  scrollContainer = React.createRef();

  scrollActiveDayTabIntoView = () => {
    const elm = this.scrollContainer.current.getElementsByClassName('active').item(0);
    if (elm)
      elm.scrollIntoView({
        behavior: 'instant',
        block: 'center',
        inline: 'center',
      });
  };
}



// WEBPACK FOOTER //
// ./src/screens/Trek/DayTabs/DayTabsDesktop.js